'use strict';

export const accordion = (() => {
  const init = () => {
    document.querySelectorAll('[data-acc-visible]').forEach(item => {
      item.onclick = function () {
        item.dataset['accVisible'] = item.dataset['accVisible'] === 'show' ? 'hide' : 'show';
      };
    });
  };

  return {
    init
  };
})();
